<template>
  <button
    :id="id"
    :disabled="loading || disabled"
    :class="{
      alertMode,
      'btn-disabled': disabled,
      secondary,
      loading,
      'green-background': greenBackground,
      [type || '']: !!type,
      fill: 'w-100',
    }"
  >
    <div v-if="loading" class="text-center">
      <div class="animatedDots">
        <div class="animatedDotsChild" />
        <div class="animatedDotsItem" />
        <div class="animatedDotsInner" />
      </div>
    </div>
    <slot v-else></slot>
  </button>
</template>

<script lang="ts" setup>
type ButtonType =
  | "primary"
  | "secondary"
  | "active-white"
  | "disabled"
  | "link"
  | "link-icon"
  | "icon"
  | "rounded";

defineProps<{
  id?: string;
  text?: string;
  disabled?: boolean;
  alertMode?: boolean;
  secondary?: boolean;
  loading?: boolean;
  greenBackground?: boolean;
  type?: ButtonType;
  fill?: boolean;
}>();
</script>

<style lang="scss" scoped>
@import "@/apps/credit-line/styles/index.scss";
$pj-color-alert-red: #e11d48;
button {
  background: $pj-color-green-new;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 100%;
  border: none;
  height: 48px;
  padding: 10px 24px;
  font-family: Inter, serif;
}

.btn-disabled {
  background-color: #8b8b8b !important;
  filter: grayscale(0.75);
  pointer-events: none;
}
.loading {
  opacity: 0.7;
  pointer-events: none;
}
.alertMode {
  background: $pj-color-alert-red;
}
.secondary {
  background: transparent;
  color: $pj-color-green;
}

.green-background {
  background: #c7fd17;
  color: $pj-color-green;
  font-weight: 600;
  font-size: 16px;
}

.animatedDots {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
}

.animatedDotsChild {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate;
}

.animatedDotsItem {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate 0.2s;
}

.animatedDotsInner {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate 0.4s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}

.link {
  background: white;
  color: var(--Primary-Main-green, #007c3b);
  font-feature-settings: "liga" off, "clig" off;

  /* Text regular-content-Page title */
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
}

.primary {
  border-radius: 5px;
  background: var(--Primary-Green-1, #007c3b);
  color: var(--Gray-elements-White, #fff);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}

.rounded {
  border-radius: 6.25rem !important;
}
</style>
